import React from "react";

import FullScreenAuthLoader from "@/ui/organisms/FullScreenAuthLoader";

export type ViewAuthInitParams = {
    useState: () => {
        isInitializingAuth: boolean;
        isAuthenticated: boolean;
        user: { email?: string } | null;
    };
    useCases: () => {
        onMount: () => void;
        onAuthenticated: (user: { email?: string }) => Promise<void>;
    };
};

export const createViewAuthInit = ({
    useState,
    useCases,
}: ViewAuthInitParams) => {
    const ViewAuthInit = ({ children }: { children: React.ReactNode }) => {
        const { onMount, onAuthenticated } = useCases();
        const { isInitializingAuth, isAuthenticated, user } = useState();

        const isAlreadyMountedRef = React.useRef(false);
        React.useEffect(() => {
            if (isAlreadyMountedRef.current) return;
            isAlreadyMountedRef.current = true;
            onMount();
        }, [onMount]);

        const isAlreadyAuthenticatedRef = React.useRef(false);
        React.useEffect(() => {
            if (isAlreadyAuthenticatedRef.current) return;
            if (!isAuthenticated) return;
            if (!user) return;

            void onAuthenticated(user);
            isAlreadyAuthenticatedRef.current = true;
        }, [isAuthenticated, user, onAuthenticated]);

        if (isInitializingAuth) {
            return <FullScreenAuthLoader label={"Initializing auth..."} />;
        }

        return children;
    };

    return ViewAuthInit;
};
